import { useContext, useState } from 'react';
import headerStyles from './styles.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import defaultStyles from '../../../css/default.module.scss';
import { faAngleRight, faBars, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Section } from '../../default/Areas/Areas';
import { HeaderProps, Links, HeaderLinksProps, LinkType } from './types';
import { UserContext } from '../../../contexts/UserContext/UserContext';
import { UserContextType } from '../../../contexts/UserContext/types';
// import LogoImage from './logo-transparent-sm.webp';
// @todo: LogoImage has issue where going to a different page reloads the logo, causing snap on load
// ^ might be as Header keeps re-rendering as it isn't memoised correctly or something

export const Header = ({ cls = '', light = false }: HeaderProps) => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const { user } = useContext<UserContextType>(UserContext);
    const headerLinks = user ? accountLinks : links;

    return (
        <Section
            clsOuter={`${headerStyles.headerOuter} ${cls} ${light ? headerStyles.light : ''}`}
            clsInner={headerStyles.headerInner}
            tag='header'
        >
            <h2>
                <Link to='/' aria-label='TopUpTest Home'>
                    {/* <img src={LogoImage} alt='logo' /> */}
                    <p>
                        <b>TopUp</b>Test
                    </p>
                </Link>
            </h2>
            <div className={`${headerStyles.rightArea} rightarea`}>
                <FontAwesomeIcon
                    icon={menuOpen ? faTimesCircle : faBars}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label='menu'
                    aria-expanded={menuOpen}
                    aria-controls='main-navigation'
                />
                <nav
                    className={`${headerStyles.rightAreaInner} ${
                        menuOpen ? headerStyles.open : ''
                    }`}
                >
                    <HeaderLinks links={headerLinks} />
                    <AccountButton light={light} />
                </nav>
            </div>
        </Section>
    );
};

const HeaderLinks = ({ links }: HeaderLinksProps) => (
    <ul>
        {links.map((link: LinkType) => (
            <li key={link.title}>
                <Link to={link.url} className='header-link'>
                    {link.title}
                    <FontAwesomeIcon icon={faAngleRight} aria-hidden='true' />
                </Link>
            </li>
        ))}
    </ul>
);

const AccountButton = ({ light = false }: { light: boolean }): JSX.Element => {
    const navigate = useNavigate();
    const { user, setAccount } = useContext<UserContextType>(UserContext);
    const text = user ? 'Log out' : 'Login';

    const onClick = () => {
        if (user) {
            setAccount(null);
        }

        navigate('/login');
    };

    return (
        <button
            onClick={onClick}
            className={`${light ? defaultStyles.btnGrey : defaultStyles.btnWhite} header-login-btn`}
            aria-label={user ? 'Log out' : 'Log in'}
        >
            {text}
        </button>
    );
};

export const links: Links = [
    // {
    //     title: 'Home',
    //     url: '/',
    // },
    {
        title: 'AI Test Ideas',
        url: '/tools/ab-test-suggester',
    },
    {
        title: 'Pricing',
        url: '/pricing',
    },
    {
        title: 'Services',
        url: '/services',
    },
    {
        title: 'About',
        url: '/about',
    },
];

export const accountLinks: Links = [
    // {
    //     title: 'Home',
    //     url: '/',
    // },
    {
        title: 'AI',
        url: '/tools/ab-test-suggester',
    },
    {
        title: 'Tests',
        url: '/user/tests',
    },
    {
        title: 'My Account',
        url: '/user',
    },
    {
        title: 'Buy Sessions',
        url: '/pricing',
    },
    {
        title: 'Services',
        url: '/services',
    },
];
